export default function isEmpty() {
  return false
}
